import { api_url } from "../../../utils";

const Provincias = {
    enable: true,
    checked: true,
    initialDisplay: true,
    excludeCities: [],
    source: "api",
    url: api_url + "maps/geojson/?table=provincias&schema_city=",
    zindex: 1,
    type: "single",
    popup: {
        default: {
            content: {
                es: {
                    provincia: "Nombre de la provincia: ",
                    población: "Población 2024: ",
                    tasa_creci:
                        "Tasa de crecimiento anualizado 2017 - 2024 (%): ",
                    pers_per_h: "Número medio de personas por hogar: ",
                    empleos: "Número de empleos:",
                    pob_activa: "% población activa: ",
                    densidad_n: "Densidad neta (hab./km²): ",
                },
            },
            separators: {
                decimal: ["tasa_creci", "pers_per_h"],
                thousand: ["población", "empleos", "densidad_n"],
            },
        },
    },
    titleSideBar: "Mobility Indicators Content.layers.Provincias",
    style: {
        regular: false,
        fillColor: "rgba(0, 0, 0, 0.001)",
        strokeColor: "rgb(0, 0, 0)",
        strokeWidth: 2.7,
        strokeLineDash: [],
        points: 0,
        radius: 0,
        angle: 0,
        rotation: 0,
    },
    legend: {
        default: {
            title: "Mobility Indicators Content.layersLegend.Provincias.title",
            subtitle: "",
            attribute: "",
            symbol: "rectangle",
            legendCustomCssClass: "map-legend-symbol-border-2-7px-dark-0-0-0",
            class: [
                {
                    fillColor: "rgba(0, 0, 0, 0)",
                    strokeColor: "rgba(0, 0, 0, 1)",
                    strokeWidth: 3,
                    label: "Mobility Indicators Content.layersLegend.Provincias.classes.1",
                },
            ],
        },
    },
};

export default Provincias;
